import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Button, Divider, Dropdown, Modal, Spin, Table } from "antd";
import {
  PlusOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { CustomForm } from "../CustomForm";
import Title from "antd/es/typography/Title";
import { useMediaQuery } from "react-responsive";
import { ModalDetalle } from "./ModalDetalle/ModalDetalle";
import { ModalAgregar } from "./ModalAgregar/ModalAgregar";

export const CustomTable = ({
  camposFilter = null,
  camposFormularioModal = null,
  queryListar = null,
  queryEditar = null,
  formatData = null,
  columns = [],
  editable = false,
  perPage = 5,
  detalle = false,
  camposAgregar = null,
  queryCrear = null,
  basicParams = { page: 1, perPage: perPage },
  tituloTabla = null,
  tituloEditar = null,
  columnNameEditar = "Editar",
  iconEditar = null,
  accionesList = null,
  refetchExternal = null,
  onClickActions = null,
  onRefetch = null,
  imagen = false,
  queryListarOut = null, // queryListar controlado por fuera del componente -> queryListarPokemon = useListarPokemon() -> de esta forma controlarlo de forma externa
  onDelete = null,
  // Nuevos props para control externo
  externalParams = null, // params externos que se combinan con los internos
  onParamsChange = null, // callback cuando cambian los params internos
  // Nuevos props para eliminación
  canDelete = false,
  queryBorrarFila = null,
  canDeleteTotal = false,
  queryBorrarTotalFila = null,
}) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [columnsTable, setColumnsTable] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [dataSelect, setDataSelect] = useState(null);
  const [params, setParams] = useState(basicParams); const [openDetalle, setOpenDetalle] = useState(false);
  const [openAgregar, setOpenAgregar] = useState(false);
  // Combinar params internos con externos
  const finalParams = externalParams ? { ...params, ...externalParams } : params;
  const queryData = queryListarOut ?? queryListar(finalParams);
  const queryBorrar = queryBorrarFila ? queryBorrarFila() : null;

  const [refetch, setRefetch] = useState(null);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  const [tableParams, setTableParams] = useState({
    pagination: {
      position: ["none", "bottomCenter"],
      current: 1,
    },
  });

  const [openImageModal, setOpenImageModal] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const handleOpenImageModal = (url) => {
    setImageSrc(url);
    setOpenImageModal(true);
  };

  // Función de eliminación con modal de confirmación
  const handleDelete = (fila) => {
    Modal.confirm({
      title: '¿Está seguro que desea eliminar este elemento?',
      content: 'Esta acción no se puede deshacer.',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sí, eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      centered: true,
      onOk: async () => {
        try {
          if (queryBorrar && fila) {
            await queryBorrar.mutateAsync(fila);
            // Refrescar la tabla después de eliminar
            if (queryData?.refetch) {
              queryData.refetch();
            }
          }
        } catch (error) {
          // Los errores ya son manejados por el hook
        }
      },
    });
  };

  // Función de eliminación total con modal de confirmación
  const handleDeleteTotal = (fila) => {
    console.log('handleDeleteTotal called', { fila, queryBorrarTotalFila });
    Modal.confirm({
      title: '¿Está seguro que desea eliminar TOTALMENTE este elemento?',
      content: 'Esta acción eliminará el registro de la base de datos y no se puede deshacer.',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sí, eliminar totalmente',
      okType: 'danger',
      cancelText: 'Cancelar',
      centered: true,
      onOk: async () => {
        try {
          console.log('onOk delete total', { fila, queryBorrarTotalFila });
          if (queryBorrarTotalFila && fila) {
            await queryBorrarTotalFila.mutateAsync(fila);
            // Refrescar la tabla después de eliminar
            if (queryData?.refetch) {
              queryData.refetch();
            }
          }
        } catch (error) {
          // Los errores ya son manejados por el hook
        }
      },
    });
  };

  // Genera el menú dinámicamente según props
  const getAccionesMenu = (fila) => {
    const items = [];
    if (imagen && fila.imagen) {
      items.push({
        key: "verImagen",
        label: "Ver Imagen",
        onClick: () => handleOpenImageModal(fila.imagen),
      });
    }
    if (editable) {
      items.push({
        key: "editar",
        label: "Editar",
        onClick: () => {
          if (formatData) {
            setDataSelect(formatData(fila));
          } else {
            setDataSelect(fila);
          }
          setOpenModal(true);
        },
      });
    } if (typeof onDelete === 'function') {
      items.push({
        key: "eliminar",
        label: <span style={{ color: 'red', fontWeight: 600 }}>Eliminar</span>,
        onClick: () => onDelete(fila),
        danger: true,
      });
    }
    if (canDelete && queryBorrarFila) {
      items.push({
        key: "eliminarModal",
        label: <span style={{ color: 'red', fontWeight: 600 }}>Eliminar</span>,
        onClick: () => handleDelete(fila),
        danger: true,
      });
    }
    console.log('getAccionesMenu canDeleteTotal', canDeleteTotal, 'queryBorrarTotalFila', !!queryBorrarTotalFila);
    if (canDeleteTotal && queryBorrarTotalFila) {
      console.log('adding eliminarTotalModal item');
      items.push({
        key: "eliminarTotalModal",
        label: <span style={{ color: '#ff4d4f', fontWeight: 600 }}>Eliminar totalmente</span>,
        onClick: () => handleDeleteTotal(fila),
        danger: true,
      });
    }
    if (detalle) {
      items.push({
        key: "detalle",
        label: "Detalle",
        onClick: () => {
          setOpenDetalle(true);
          setDataSelect(fila);
        },
      });
    }

    if (accionesList) {
      // Si hay acciones custom, las agrega al final
      accionesList.forEach((accion) => {
        items.push({
          key: accion.key,
          label: accion.label,
          accionOnClick: accion.onClick, // Guardamos la función
          filaAccion: fila, // Guardamos la fila
        });
      });
    }

    return items;
  };

  // Columna única de acciones — useMemo para que se recalcule cuando cambian canDelete/queryBorrarFila
  const columnaAcciones = useMemo(() => ({
    title: "Acciones",
    key: "acciones",
    fixed: "right",
    width: "8%",
    render: (fila) => {
      const items = getAccionesMenu(fila);
      if (items.length === 0) return null;
      // Creamos un diccionario de handlers por key
      const handlers = {};
      const menuItems = items.map(({ key, label, onClick, accionOnClick }) => {
        // Si es acción personalizada
        if (accionOnClick) {
          handlers[key] = () => {
            if (typeof accionOnClick === 'function') accionOnClick(fila);
            if (typeof onClickActions === 'function') onClickActions(fila, key);
          };
        } else if (onClick) {
          // Si es acción estándar
          handlers[key] = onClick;
        }
        return { key, label };
      });
      return (
        <Dropdown
          menu={{
            items: menuItems,
            onClick: ({ key }) => {
              if (handlers[key]) handlers[key]();
            },
          }}
          trigger={["click"]}
        >
          <Button
            data-testid="btn-acciones"
            icon={<UnorderedListOutlined />}
            onClick={e => e.stopPropagation()}
          >
            Acciones
          </Button>
        </Dropdown>
      );
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [imagen, editable, detalle, accionesList, onDelete, canDelete, queryBorrarFila, queryBorrar, canDeleteTotal, queryBorrarTotalFila]);

  useEffect(() => {
    if (columns) {
      let aux = [...columns];
      // Elimina columnas individuales de acciones si existen
      aux = aux.filter(
        (col) =>
          col.key !== "verImagen" &&
          col.key !== "editar" &&
          col.key !== "detalle" &&
          col.key !== "acciones"
      );
      aux.push(columnaAcciones);
      setColumnsTable(aux);
    }
  }, [columns, imagen, editable, detalle, accionesList, onDelete, canDelete, queryBorrarFila, columnaAcciones]);

  // Sync internal params when basicParams changes (e.g., user selection change)
  useEffect(() => {
    if (basicParams) {
      setParams((prev) => {
        const newPage = tableParams.pagination?.current ?? prev.page;
        const hasChanged =
          prev.usua_id !== basicParams.usua_id ||
          prev.page !== newPage ||
          prev.perPage !== basicParams.perPage;
        if (!hasChanged) return prev;
        return {
          ...prev,
          ...basicParams,
          page: newPage,
        };
      });
    }
  }, [basicParams, tableParams.pagination?.current]);

  // Callback para notificar cambios de params externos (solo en cambios de paginación normal)
  useEffect(() => {
    if (onParamsChange && !externalParams) {
      onParamsChange(params);
    }
  }, [params.page, params.perPage]); // Solo para cambios de paginación
  useEffect(() => {
    if (queryData.isSuccess) {
      setData(queryData.data?.data ?? []);
      setTableParams((prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          pageSize: perPage,
          total: queryData.data?.total ?? 0,
        },
      }));
    }
  }, [queryData.isSuccess, queryData.isRefetching]);

  // Manejo de éxito en eliminación
  useEffect(() => {
    if (queryBorrar?.isSuccess) {
      // Refrescar la tabla después de eliminar
      if (queryData?.refetch) {
        queryData.refetch();
      }
    }
  }, [queryBorrar?.isSuccess]);

  const handleTableChange = (pagination, filters) => {
    setTableParams((prev) => ({
      ...prev,
      pagination: { ...prev.pagination, current: pagination.current },
      filters,
    }));
  };

  return (
    <Fragment>
      {camposFilter && (
        <>
          <Title style={{ textAlign: "center" }}>
            {tituloTabla ?? "Edición de " + camposFilter.title}
          </Title>
          <Divider variant="solid" style={{ borderColor: "#000" }} />
          {camposFilter && (
            <CustomForm
              name={"filter-table"}
              camposFormulario={camposFilter}
              isFilter={true}
              queryFilter={(form) => {
                const addParams = Object.fromEntries(
                  Object.entries(form).filter(
                    ([_, value]) => value !== undefined
                  )
                );
                // Resetear la página a 1 cuando se aplican filtros
                const newParams = { ...params, ...addParams, page: 1 };
                setParams(newParams);
                
                // También resetear el estado de paginación de la tabla
                setTableParams((prev) => ({
                  ...prev,
                  pagination: {
                    ...prev.pagination,
                    current: 1,
                  },
                }));
                
                // Notificar cambios de params si hay callback (solo los params del filtro + paginación)
                if (onParamsChange) {
                  onParamsChange(newParams);
                }
              }}
              create={false}
            />
          )}

          {camposAgregar && (
            <>
              <Button
                type="primary"
                onClick={() => setOpenAgregar(true)}
                style={{ marginBottom: "1rem" }}
              >
                <PlusOutlined />
              </Button>
            </>
          )}

          <Table
            columns={columnsTable}
            rowKey={(data) => data.id}
            dataSource={data}
            pagination={{
              ...tableParams.pagination,
              showSizeChanger: false, // Oculta el selector de cantidad por página
            }}
            loading={loading}
            onChange={handleTableChange}
            scroll={{
              x: "max-content",
            }}
            bordered
          />
          {openModal && dataSelect && camposFormularioModal && (
            <Modal
              title={tituloEditar ?? `Editar: ${dataSelect.nombre ?? dataSelect.titulo}`}
              open={openModal}
              footer={null}
              onCancel={() => setOpenModal(false)}
              cancelText="Cancelar"
              width={isDesktopOrLaptop ? "50%" : "100%"}
            >
              {/* Renderiza contenido extra si está presente en camposFormularioModal */}
              {camposFormularioModal?.extra && (
                <div style={{ marginBottom: 16 }}>{camposFormularioModal.extra}</div>
              )}
              <CustomForm
                name={`editar-${dataSelect.nombre}`}
                camposFormulario={camposFormularioModal}
                initialValues={dataSelect}
                create={false}
                querySubmit={queryEditar}
                setOpenModal={setOpenModal}
                setRefetch={setRefetch}
              />
            </Modal>
          )}
          {openDetalle && detalle && (
            <Modal
              title={`Detalle`}
              open={openDetalle}
              footer={null}
              onCancel={() => setOpenDetalle(false)}
              cancelText="Cancelar"
              width={isDesktopOrLaptop ? "50%" : "100%"}
            >
              <ModalDetalle data={dataSelect} />
            </Modal>
          )}
          {openAgregar && camposAgregar && (
            <Modal
              title={`Agregar`}
              open={openAgregar}
              footer={null}
              onCancel={() => setOpenAgregar(false)}
              cancelText="Cancelar"
              width={isDesktopOrLaptop ? "50%" : "100%"}
            >
              {/* Renderiza contenido extra si está presente en camposAgregar */}
              {camposAgregar?.extra && (
                <div style={{ marginBottom: 16 }}>{camposAgregar.extra}</div>
              )}
              <ModalAgregar
                camposAgregar={camposAgregar}
                queryCrear={queryCrear}
                setRefetch={setRefetch}
                setOpenModal={setOpenAgregar}
              />
            </Modal>
          )}

          <Modal
            title="Vista previa de la imagen"
            open={openImageModal}
            footer={null}
            onCancel={() => setOpenImageModal(false)}
            width={600}
          >
            {imageSrc && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <img
                  src={imageSrc}
                  alt="Vista previa"
                  //style={{ width: "100%", borderRadius: "8px" }}

                  style={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    objectFit: "contain",
                    imageRendering: "pixelated", // Mantiene el pixel-art sin difuminar
                  }}
                /></div>
            )}
          </Modal>

          {queryData.isFetching && (
            <Spin fullscreen={true} tip="Cargando..."></Spin>
          )}
        </>
      )}
    </Fragment>
  );
};
